/**
 * Traffic-light status for the body-composition metrics coaches watch most
 * closely (weight/BMI, body fat %, muscle mass). Bands mirror the app's
 * `bodyCompositionHealthStatus` UI thresholds (MealMap/src/utils), collapsed
 * to a 3-color coaching signal: green (on track), yellow (watch), red (flag).
 *
 * "High" is favorable for muscle mass, so its green/red mapping is inverted
 * relative to weight/body fat, where low is favorable.
 */
export function bmiTrafficLight(bmi) {
    if (bmi < 18.5) {
        return 'yellow';
    }
    if (bmi < 25) {
        return 'green';
    }
    if (bmi < 30) {
        return 'yellow';
    }
    return 'red';
}
export function bodyFatTrafficLight(pct, isMale) {
    const male = isMale !== false;
    if (male) {
        if (pct < 20) {
            return 'green';
        }
        if (pct < 25) {
            return 'yellow';
        }
        return 'red';
    }
    if (pct < 28) {
        return 'green';
    }
    if (pct < 32) {
        return 'yellow';
    }
    return 'red';
}
/** `pct` is muscle mass as a percentage of body weight. */
export function muscleMassTrafficLight(pct, isMale) {
    const male = isMale !== false;
    const avgMax = male ? 45 : 38;
    const lowMax = male ? 38 : 32;
    if (pct >= avgMax) {
        return 'green';
    }
    if (pct >= lowMax) {
        return 'yellow';
    }
    return 'red';
}
/**
 * Did the traffic light improve, worsen, or stay the same between two
 * readings? Used to call out "yellow -> green" wins and "green -> yellow" /
 * "yellow -> red" flags without the caller needing to know which color is
 * favorable for a given metric.
 */
export function trafficLightTransition(prev, current) {
    if (!prev) {
        return null;
    }
    const rank = {
        red: 0,
        yellow: 1,
        green: 2,
    };
    if (rank[current] > rank[prev]) {
        return 'improved';
    }
    if (rank[current] < rank[prev]) {
        return 'worsened';
    }
    return 'unchanged';
}
